import CoreMessageDispatcher from '../../core/controller/CoreMessageDispatcher';
import CoreEvents from '../../core/events/CoreEvents';

const _dispatcher = CoreMessageDispatcher.instance();

const _start = mdr => {
    if (mdr.started) return mdr;

    mdr._update(true);
    _addCoreListeners(mdr, true);

    mdr.started = true;
    return mdr;
};

const _stop = mdr => {
    if (!mdr.started) return mdr;

    _addCoreListeners(mdr, false);

    mdr.started = false;
    return mdr;
};

const _update = (mdr, force) => {
    if (!mdr.started && !force) return mdr;

    const isOn = mdr.model.currentEventId === mdr.eventId && mdr.model.currentEventOpened;
    const stateChanged = mdr.state.isOn !== isOn;
    mdr.state.isOn = isOn;

    if (!stateChanged) return mdr;

    // View: can be substituted by JS-animation
    mdr.el.dataset.showStory = mdr.state.isOn;
    // TODO: play animation

    return mdr;
};

//

//
// From Core
//
const _addCoreListeners = (mdr, b) => {
    if (b) {
        _dispatcher.on(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
        _dispatcher.on(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
        return;
    }

    _dispatcher.off(CoreEvents.MODEL_STATE_CHANGED, mdr._update);
    _dispatcher.off(CoreEvents.CURRENT_EVENT_STATE_CHANGED, mdr._update);
};

//

//
// Constructor
//
const StoryDisplayMediator = (el, model) => {
    const mdr = {
        el: el,
        model: model,
        eventId: el.dataset.eventId,
        state: {
            isOn: false
        }
    };

    // TODO: _construct(mdr);

    mdr.start = () => {
        return _start(mdr);
    };

    mdr._update = force => {
        return _update(mdr, force);
    };

    mdr.stop = () => {
        return _stop(mdr);
    };

    return mdr;
};

export {StoryDisplayMediator};
export default StoryDisplayMediator;
